import { useAuth } from "auth/AuthContext";
import { useAuthMachine } from "auth/state/hook";
import { useFetch } from "utils/query";

export const BOOTSTRAP_PATH = "/orkesHosted/aws/bootstrap";
export type HostedOptions = { enabled: boolean; regions: string[] };
export type HostedStatus = {
  operationId: string;
  state:
    | "PLANNED"
    | "CREATING"
    | "STACK_READY"
    | "FAILED"
    | "RECONCILIATION_REQUIRED";
  clusterName: string;
  accountId: string;
  region: string;
  vpcId: string | null;
  vpcCidr: string | null;
};

export function useHostedOptions() {
  const { authService } = useAuth();
  const [
    {
      canManageEnvironment,
      currentOrganization,
      currentUser,
      currentProfile,
      isSwitchingOrganization,
    },
  ] = useAuthMachine(authService);
  return useFetch<HostedOptions>(
    [
      BOOTSTRAP_PATH + "/options",
      currentOrganization?.id ?? "",
      currentUser?.uid ?? "",
      currentProfile ?? "",
      String(canManageEnvironment),
    ],
    {
      paramsAvailable:
        canManageEnvironment &&
        !!currentOrganization &&
        !isSwitchingOrganization,
      keepPreviousData: false,
      retry: false,
      staleTime: 0,
    }
  );
}
